import React, {useEffect, useState, useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import RecoverySuccess from './RecoverySuccess';
import Header from '../Units/Header';
import { requestRecovery } from "../../store/actionCreators/authentication";
import '../../assets/stylesheets/PasswordRecovery.scss';


const PasswordRecovery =({}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [email, setEmail] = useState('');
    const [validEmail, setValidEmail] = useState(true);
    const [tempSuccess, setTempSuccess] = useState(false);
    const {success: recovery, recoveryError} = useSelector(state => state.authData);

    const insertEmail = useCallback((e) => {
        setEmail(e.target.value);
    }, [email, setEmail]);

    useEffect(() => {
        const emailString = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isValid = emailString.test(email);
        setValidEmail(isValid);
    }, [email]);

    useEffect(() => {
        recovery && setTempSuccess(true);
    }, [recovery])

    const initRecovery = () => {
        dispatch(requestRecovery({email: email}));
    };

    return (
        <div className='passwordRecovery'>
            <Header />
            {tempSuccess ? 
            <RecoverySuccess></RecoverySuccess>:
            <React.Fragment>
                    <div className={'logoSection'}>
                        <div className={'recoveryLogo'}></div>
                        <span className={'recoveryTitle'}>{t('passwordRecovery.title')}</span>
                        <span className={'recoveryDescription'}>{t('passwordRecovery.description')}</span>
                    </div>
                    <div className={'inputSection'}>
                        <div className="emailField">
                            {t('passwordRecovery.emailField')}
                            <label className={`${(recoveryError && (recoveryError.code === 400 || 404) || ((email.length > 0) && !validEmail)) ? 'fieldError' : ''}`}>
                                <input type='text' className="emailInput" placeholder={t('email')}
                                    onChange={(e) => insertEmail(e)}
                                />
                                {(recoveryError && (recoveryError.code === 400 || 404) || ((email.length > 0) && !validEmail)) ? <span className={`failedField`}></span> : ""}
                                {(validEmail && !recoveryError) && <span className={`successField`}></span>}
                            </label>
                            <span className="errorMessage alignErr">
                                {
                                    (email.length > 0) ? 
                                    ((!validEmail ? t('error.signInUp.5') : (recoveryError && (recoveryError.code === 400 || 404)) && t('error.signInUp.6'))) 
                                    : (recoveryError && t('error.signInUp.7'))
                                }
                            </span>
                        </div>
                    </div>
                    
                    <div className={`sendSection`}>
                        <button className={`primary`} onClick={() => initRecovery()}> {t('passwordRecovery.sendEmail')}</button>
                    </div>
            </React.Fragment>}
        </div>
    );
};

export default PasswordRecovery;
